import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import useScreenSize from "hoc/useScreenSize";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import { getModelIconUrl } from "../../../util/helper/getModelIconUrl";
import styles from "../style-component.module.scss";

function ModelCard(props: any) {
  const {
    url, model, year, tier, jsLink = false, label: title, make, displayableModel, onClick,
  } = props;
  const label = tier || displayableModel || year || title;
  const [isMobile, ,] = useScreenSize();

  const router = useRouter();
  const renderItem = (
    <span className="item">

      <PAText fontSize={FONT_SIZE[2]}>{label}</PAText>
      <HideIf show={!isMobile}>
        {make && model && (
          <Image
            alt={displayableModel}
            src={getModelIconUrl({ make, model })}
            width={100}
            height={50}
            unoptimized
            className={styles.model_mages}
          />
        )}
      </HideIf>
      <HideIf show={isMobile}>
        <i className={`fa icon-right fa fa-chevron-right ${styles.right_arrow}`} />
      </HideIf>
    </span>
  );
  return (
    <div className={styles.style_model_item}>
      {
        jsLink && (
          <div onClick={(e) => {
            e.preventDefault();
            if (e.ctrlKey && url) {
              window.open(url, "_blank");
            } else if (url) {
              router.push(url)
                .then(() => window.scrollTo(0, 0));
            } else if (onClick) {
              onClick(e, { make, model, year });
            }
          }}
          >
            {renderItem}
          </div>
        )
      }
      {
        !jsLink && (
          <Link href={url}>
            {renderItem}
          </Link>
        )
      }
    </div>
  );
}

export default ModelCard;
